import React from "react";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import SaveIcon from "@material-ui/icons/Save";
import _ from "lodash";
import exportFromJSON from "export-from-json";

const useStyles = makeStyles((theme) => ({
  button: {
    margin: theme.spacing(1),
    width: "120px",
    padding: "6px 16px",
  },
}));

function ButtonExport(props) {
  const classes = useStyles();

  const download = (exportType) => {
    const exportObject = {};

    props.berData.forEach((val) => {
      _.set(
        exportObject,
        val.key.substring(0, 0) + val.key.substring(1),
        val.value
      );
    });

    const exported = JSON.stringify(exportObject);

    exportFromJSON({
      data: exported,
      fileName: props.fileNameValue,
      exportType: exportFromJSON.types.json,
    });
  };
  console.log(props.berData);
  return (
    <>
      <Button
        variant="contained"
        color="primary"
        size="large"
        className={classes.button}
        startIcon={<SaveIcon />}
        onClick={download}
      >
        Export
      </Button>
    </>
  );
}

export default ButtonExport;
